import { render, staticRenderFns } from "./message_form.vue?vue&type=template&id=7b55355d&"
import script from "./message_form.vue?vue&type=script&lang=js&"
export * from "./message_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports